import { EditOutlined } from '@ant-design/icons';
import { Button, Card, Flex, Table, TableProps } from 'antd';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import OrderSearch from '../../lib/OrderSearch';
import { Fragment, useCallback, useEffect, useMemo, useState } from 'react';
import dayjs from 'dayjs';
import { notifyError, priceFormat } from '../../store/utils';
import { ColumnsType, TablePaginationConfig } from 'antd/es/table';
import { parseSearchParam } from '../../store/orderUtils';
import queryString from 'query-string';
import { PagedResultState } from '../../common/CommonResult';
import { API } from '../../api';

const OrderCancel = () => {
  const navigate = useNavigate();

  const onSerach = useCallback(async (query: any) => {
    navigate(`/order/cancel?${queryString.stringify(query)}`);
  }, []);

  return (
    <Card title="Цуцалсан захиалга">
      <Flex gap={24} vertical>
        <OrderSearch isPrint={false} onSearch={(params: any) => onSerach(params)} />
        <OrderView />
      </Flex>
    </Card>
  );
};
export default OrderCancel;

const OrderView = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [selected, setSelected] = useState<any[]>([]);

  const [state, setState] = useState<PagedResultState<any>>({
    loading: true,
    result: {},
  });

  const fetchOrdersList = useCallback(async () => {
    setState({
      loading: true,
      result: state.result || {},
    });
    try {
      const { result } = await API.get({ apiVersion: 'api' })(
        `/order/cancel${location.search}&status=CANCEL`
      );
      setState({
        loading: false,
        result,
      });
    } catch (error: any) {
      notifyError(error.message);
    }
  }, [location, state]);

  useEffect(() => {
    if (location.search) {
      fetchOrdersList();
    }
  }, [location]);

  useEffect(() => {
    if (!location.search) {
      const params = parseSearchParam({});
      navigate(`/order/cancel?${queryString.stringify(params)}`);
    }
  }, [location]);

  const handleTableChange = useCallback(
    (pagination: TablePaginationConfig) => {
      const params = queryString.parse(location.search);
      const search = {
        ...params,
        page: pagination.current || 1,
        size: pagination.pageSize || 10,
      };
      navigate(`/order/cancel?${queryString.stringify(search)}`);
    },
    [location, navigate]
  );

  const columns: ColumnsType<any> = [
    {
      title: '#',
      key: 'shipmentOrderNo',
      width: 100,
      fixed: 'left',
      render: (val: number, row: any) => (
        <Link to={`/order/detail/${row.order?.no}`}>#{row.order?.no}</Link>
      ),
    },
    {
      title: 'Огноо',
      width: 100,
      fixed: 'left',
      render: (val: string, row: any) => (
        <span>{dayjs(row.createdAt).format('YYYY-MM-DD HH:mm')}</span>
      ),
    },
    {
      title: 'ИА.Салбар',
      width: 120,
      render: (val: any, row: any) => <span>{row?.order?.firstBranch?.name}</span>,
    },
    {
      title: 'ИА.Хүргэгч',
      width: 150,
      render: (val: any, row: any) => <span>{row?.order?.firstDeliveryMan?.firstName}</span>,
    },
    {
      title: 'Илгээгч',
      render: (val: any, row: any) => (
        <div>
          <span style={{ display: 'block' }}>
            {row?.order?.senderFname + ' ' + row?.order?.senderPhone1}
          </span>
          <span>
            {row?.order?.senderProvinceName} {row?.order?.senderDistrictName}{' '}
            {row?.order?.senderAddressDetail}
          </span>
        </div>
      ),
    },
    {
      title: 'Хүргэлт',
      width: 80,
      render: (val: any, row: any) => <span>{row.order?.deliveryType?.text}</span>,
    },
    {
      title: 'Хэмжээ',
      dataIndex: 'weightType',
      width: 80,
      render: (val: any) => <span>{val?.name}</span>,
    },
    {
      title: 'Дүн',
      dataIndex: 'price',
      width: 80,
      render: (val: number) => <span>{priceFormat(val)}₮</span>,
    },
    {
      title: 'Суваг',
      width: 100,
      render: (val: any, row: any) => <span>{row?.order?.channelType?.text} </span>,
    },
    {
      title: 'Харилцагч',
      width: 100,
      render: (val: any, row: any) => <span>{row.order?.customer?.name} </span>,
    },
    {
      title: 'Баримт ',
      width: 120,
      render: (val: any, row: any) => <div>{row?.barcode}</div>,
    },
    // {
    //   title: 'Үйлдэл',
    //   key: 'action',
    //   width: 90,
    //   fixed: 'right',
    //   render: (val: any, row: any) =>
    //     <div>
    //       <Button
    //         size="small"
    //         type="default"
    //         icon={<EditOutlined />}
    //         onClick={() => navigate(`/order/update/${row.order?.no}`)}
    //       />
    //     </div>
    // }
  ];

  const selectedRowKeys = useMemo(() => {
    return selected.map((itm) => itm.no);
  }, [selected]);

  const rowSelection: TableProps<any>['rowSelection'] = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
      console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
      setSelected(selectedRows);
    },
    selectedRowKeys,
    getCheckboxProps: (record: any) => ({
      disabled: record.name === 'Disabled User',
      name: record.name,
    }),
  };

  return (
    <Fragment>
      <Flex vertical gap={24}>
        <Flex>
          <div>
            Нийт тоо: <b>{state?.result?.total}ш</b> Нийт дүн:{' '}
            <b>{priceFormat(state?.result?.amount || 0)}₮</b>
          </div>
        </Flex>
      </Flex>
      <Table
        rowKey={(record: any) => record.no}
        size="small"
        scroll={{ x: 1340 }}
        loading={state.loading}
        columns={columns}
        rowSelection={rowSelection}
        pagination={{
          current: state?.result?.page || 1,
          size: 'small',
          pageSize: state?.result?.size || 10,
          total: state?.result?.total,
          position: ['bottomRight', 'topRight'],
        }}
        onChange={handleTableChange}
        dataSource={state.result.data || []}
      />
    </Fragment>
  );
};
